import { render, staticRenderFns } from "./emailLogs.vue?vue&type=template&id=50243280&scoped=true&"
import script from "./emailLogs.vue?vue&type=script&lang=js&"
export * from "./emailLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50243280",
  null
  
)

export default component.exports